import NavMenu from '../views/pages/Shared/NavMenu.vue';
import { EnpsDashboardPage } from '../views/pages/EnpsDashboard';

export default [
    {
        name: 'enps-dashboard',
        path: '/enps-dashboard',
        components: {
            menu: NavMenu,
            default: EnpsDashboardPage,
        },
    },
];
